import federation from '/opt/app-root/src/pod/client-web/dynamic/node_modules/@module-federation/webpack-bundler-runtime/dist/index.cjs.js';
import plugin_0 from '/opt/app-root/src/pod/client-web/dynamic/node_modules/@module-federation/data-prefetch/dist/plugin.esm.js';
import plugin_1 from '/opt/app-root/src/pod/client-web/dynamic/node_modules/@module-federation/data-prefetch/dist/shared.esm.js';
if (!__webpack_require__.federation.runtime) {
  var prevFederation = __webpack_require__.federation;
  __webpack_require__.federation = {};
  for (var key in federation) {
    __webpack_require__.federation[key] = federation[key];
  }
  for (var key in prevFederation) {
    __webpack_require__.federation[key] = prevFederation[key];
  }
}
if (!__webpack_require__.federation.instance) {
  var pluginsToAdd = [plugin_0 ? (plugin_0.default || plugin_0)() : false, plugin_1 ? (plugin_1.default || plugin_1)() : false].filter(Boolean);
  __webpack_require__.federation.initOptions.plugins = __webpack_require__.federation.initOptions.plugins ? __webpack_require__.federation.initOptions.plugins.concat(pluginsToAdd) : pluginsToAdd;
  __webpack_require__.federation.instance = __webpack_require__.federation.runtime.init(__webpack_require__.federation.initOptions);
  if (__webpack_require__.federation.attachShareScopeMap) {
    __webpack_require__.federation.attachShareScopeMap(__webpack_require__);
  }
  if (__webpack_require__.federation.installInitialConsumes) {
    __webpack_require__.federation.installInitialConsumes();
  }
  if (!__webpack_require__.federation.isMFRemote && __webpack_require__.federation.prefetch) {
    __webpack_require__.federation.prefetch();
  }
}